module.exports = __webpack_public_path__ + "img/open_app_top_kd.89df081d.png";